import { Dispatch } from 'redux';
import URLConstants from '../constants/url.constants';
import * as services from '../services/services';
import fileType from '../types/downloadFile.type';

export const getAllFile = (currentPage: number, pagerSize: number) => {
	return (dispatch: Dispatch) => {
		dispatch(getAllFileStart());
		let url = URLConstants.GetAllFile  + '?pageNo=' + currentPage + '&pageSize=' + pagerSize;
		services.get(url)
			.then(response => {
				dispatch(getAllFileSuccess(response.data));
			})
			.catch(err => {
				dispatch(getAllFileError(err));
			});
	};
};

const getAllFileStart = () => {
	return {
		type: fileType.GET_ALL_FILE_START
	};
};

const getAllFileSuccess = (data: any) => {
	return {
		type: fileType.GET_ALL_FILE_SUCCESS,
		payload: data
	};
};

const getAllFileError = (data: any) => {
	return {
		type: fileType.GET_ALL_FILE_ERROR,
		payload: data
	};
};


export const deleteFile = (id: number) => {
	return (dispatch: Dispatch) => {
		dispatch(deleteFileStart());
		let url = URLConstants.DeleteCSVFile + '/' + id;
		services.deleteapi(url)
			.then(response => {
				if (response.data)
					dispatch(deleteFileSuccess(response.data));
				else
					dispatch(deleteFileError('Message_Some_Error_Occured'));
			})
			.catch(err => {
				dispatch(deleteFileError(err));
			});
	};
};

const deleteFileStart = () => {
	return {
		type: fileType.DELETE_FILE_START
	};
};

const deleteFileSuccess = (data: any) => {
	return {
		type: fileType.DELETE_FILE_SUCCESS,
		payload: data
	};
};

const deleteFileError = (data: any) => {
	return {
		type: fileType.DELETE_FILE_ERROR,
		payload: data
	};
};

const resetDeleteFileDispatcher = () => {
	return {
		type: fileType.RESET_DELETE_FILE_STATE
	};
};

export const resetDeleteFileState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetDeleteFileDispatcher());
	};
};

const filePreparationStart = () => {
	return {
		type: fileType.FILE_PREPARATION_START
	};
};

const filePreparationSuccess = (data: any) => {
	return {
		type: fileType.FILE_PREPARATION_SUCCESS,
		payload: data
	};
};

const filePreparationError = (data: any) => {
	return {
		type: fileType.FILE_PREPARATION_ERROR,
		payload: data
	};
};

const resetfilePreparationDispatcher = () => {
	return {
		type: fileType.RESET_FILE_PREPARATION_STATE
	};
};

export const resetfilePreparationState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetfilePreparationDispatcher());
	};
};

export const filePreparation = (downloadURL: string, downloadData: any) => {
	return (dispatch: Dispatch) => {
		dispatch(filePreparationStart());
		services.post(downloadURL, downloadData)
			.then(response => {
				dispatch(filePreparationSuccess(response.data));
			})
			.catch(err => {
				dispatch(filePreparationError(err));
			});
	};
};

export const deleteSelectedFile = (rows: number[]) => {
	return (dispatch: Dispatch) => {
		dispatch(deleteSelectedFileStart());
		let url = URLConstants.DeleteSelectedCSVFiles
		services.deletePostapi(url,{IDs:rows})
			.then((response:any) => {
				if (response.data)
					dispatch(deleteSelectedFileSuccess(response.data));
				else
					dispatch(deleteSelectedFileError('Message_Some_Error_Occured'));
			})
			.catch((err:any) => {
				dispatch(deleteSelectedFileError(err));
			});
	}
}

const deleteSelectedFileStart = () => {
	return {
		type: fileType.DELETE_SELECTED_FILE_START
	}
}

const deleteSelectedFileSuccess = (data: any) => {
	return {
		type: fileType.DELETE_SELECTED_FILE_SUCCESS,
		payload: data
	};
};

const deleteSelectedFileError = (data: any) => {
	return {
		type: fileType.DELETE_SELECTED_FILE_ERROR,
		payload: data
	};
};

const resetDeleteSelectedFileDispatcher = () => {
	return {
		type: fileType.RESET_DELETE_SELECTED_FILE_STATE
	};
};

export const resetDeleteSelectedFileState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetDeleteSelectedFileDispatcher());
	};
};